import { MutationCache, QueryCache, QueryClient, QueryClientConfig } from 'react-query';
import { HttpError } from 'ra-core';
import { httpErrorValidation } from '../validators';

const queryLogger =
  (name: any, res: any, log = false) =>
  (...data: any) => {
    if (log) console.log(name, data);
    return res;
  };
const queryCacheSettings = {
  refetchOnMount: true,
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
};

export const generateQueryClient = (
  config: QueryClientConfig = {},
  environment = 'production',
  transformKeys?: { [key: string]: string },
  enableLogger?: boolean
) =>
  new QueryClient({
    ...config,
    queryCache: new QueryCache({
      onError(error: HttpError, query) {
        console.log(error, error.body, query);
        httpErrorValidation(error, query, transformKeys);
      },
      ...(config.queryCache || {}),
    }),
    mutationCache: new MutationCache({
      onError(error: HttpError, variables, context, mutation) {
        console.log(error, error.body, mutation);
        httpErrorValidation(error, mutation, transformKeys);
      },
      ...(config.mutationCache || {}),
    }),
    defaultOptions: {
      queries: {
        refetchOnMount:
          environment === 'development'
            ? queryLogger(
                'refetchOnMount',
                queryCacheSettings.refetchOnMount,
                enableLogger
              )
            : queryCacheSettings.refetchOnMount,
        refetchOnReconnect:
          environment === 'development'
            ? queryLogger(
                'refetchOnReconnect',
                queryCacheSettings.refetchOnReconnect,
                enableLogger
              )
            : queryCacheSettings.refetchOnReconnect,
        refetchOnWindowFocus:
          environment === 'development'
            ? queryLogger(
                'refetchOnWindowFocus',
                queryCacheSettings.refetchOnWindowFocus,
                enableLogger
              )
            : queryCacheSettings.refetchOnWindowFocus,
        refetchInterval: false,
      },
      ...(config.defaultOptions || {}),
    },
  });
